import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9316 19H5.28422C3.74896 19 2.5 17.7384 2.5 16.1875V6.66016C2.5 5.1093 3.74896 3.84766 5.28422 3.84766H11.9316C13.4668 3.84766 14.7158 5.1093 14.7158 6.66016V16.1875C14.7158 17.7384 13.4668 19 11.9316 19ZM5.28422 5.25391C4.51666 5.25391 3.89211 5.8848 3.89211 6.66016V16.1875C3.89211 16.9629 4.51666 17.5938 5.28422 17.5938H11.9316C12.6991 17.5938 13.3237 16.9629 13.3237 16.1875V6.66016C13.3237 5.8848 12.6991 5.25391 11.9316 5.25391H5.28422ZM17.5 14.4297V3.8125C17.5 2.26164 16.251 1 14.7158 1H6.98956C6.6051 1 6.2935 1.31476 6.2935 1.70312C6.2935 2.09149 6.6051 2.40625 6.98956 2.40625H14.7158C15.4833 2.40625 16.1079 3.03714 16.1079 3.8125V14.4297C16.1079 14.8181 16.4195 15.1328 16.8039 15.1328C17.1884 15.1328 17.5 14.8181 17.5 14.4297Z",
		fill: "currentColor"
	})
});
export default SvgCopy;
